export class OutOfJurisdictionRegistrationModel {
    public commercialOutOfJurisdictionRegistrationId?: number;
    public plateNumber: string;
    public vehicleId: number;
    public jurisdictionId: number;
    public expirationDate: Date;
    public updatedDate?: Date;
    public updatedBy?: string;
    public active: boolean;
}
